<template>
    <main role="main" class="container text-center">
        <h1>Create Account</h1>
        <notices :errors="errors" :notices="notices"></notices>
        <div class="row justify-content-md-center">
            <p>
            </p>
        </div>
        <div class="row justify-content-md-center">
            <form>
                <div class="form-row">
                    <div class="form-group">
                        <input v-model="input.name" id="form-name" class="form-control" placeholder="Name">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group">
                        <input v-model="input.email" id="form-email" class="form-control" placeholder="Email Address">
                    </div>
                </div>
                <b-button type="button" v-on:click="register()" variant="btn btn-primary m-2">Create Account</b-button>
            </form>
        </div>
    </main>
</template>

<script>
import axios from 'axios';
import Notices from '../components/Notices.vue';
import AppConfig from '../util/config';
export default {
    components: { Notices },
    name: "register",
    data() {
        return {
            errors: [],
            notices: [],
            input: {
                name: "",
                email: ""
            }
        }
    },
    methods: {
        validateForm() {
            this.errors = [];
            this.input.name = this.input.name.trim()
            this.input.email = this.input.email.trim()

            if (!this.input.name.length) {
                this.errors.push("Name cannot be empty");
            }

            var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!re.test(this.input.email)) {
                this.errors.push("Email address is invalid");
            }

            if (!this.errors.length) { return true; }
            return false

        },
        register() {
            this.errors = [];
            this.notices = [];
            var self = this;
            var successMessage = "Thank you for registering! You should receive welcome email and login instructions shortly.";
            var accountExistsMessage = "Oops, looks like this account already exists. Try signing in.";
            if (!this.validateForm()) { window.scrollTo(0,0); return; }

            var config = {};
            axios.post(AppConfig.BACKEND_ENDPOINT + "/auth/signup", this.input, config).then(result => {
                var accountId = result.data.data;
                this.input = {};
                this.notices.push(successMessage);
                this.$emit("notice", successMessage);
                this.$emit("registered", accountId);
            }).catch(e => {
                if (e.response.data.error == "ACCOUNT_EXISTS") {
                    self.errors.push(accountExistsMessage);
                } else {
                    self.errors.push(e.response.data.error);
                }
            }) 
        }
    },
    mounted() {
    }
}
</script>

<style scoped>
    #login {
        width: 500px;
        border: 1px solid #CCCCCC;
        background-color: #FFFFFF;
        margin: auto;
        margin-top: 200px;
        padding: 20px;
    }
</style>